import { SettingService } from 'src/app/system-common/services/setting.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashboardServiceHandler } from './dashboard.service.handler';

@Injectable({
  providedIn: 'root',
})
export class DashboardService extends DashboardServiceHandler {
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
